import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { PriceLevelsEffects } from './price-levels.effects';
import { IPriceLevelsFeature } from './price-levels.feature.state';
import { priceLevelsReducer } from './price-levels.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IPriceLevelsFeature>('priceLevelsFeature'), priceLevelsReducer),
    EffectsModule.forFeature([PriceLevelsEffects]),
  ],
})
export class PriceLevelsStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: PriceLevelsStateModule
  ) {
    if (parentModule) {
      throw new Error('PriceLevelsStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
